import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Hyperlink } from '../../../components/Hyperlink';
import { buildUrlWithParameters } from '../../../utils/url-utils/urlUtils';
import styles from './commented_decision.module.scss';
import { useRestrictedModal } from '../../../components/modal/useRestrictedModal';
import { useUser } from '../../../user/useUser';
import { ExcerptRelated } from '../../../components/excerpt/related/ExcerptRelated';
import { CommentaryBase } from '../../commentary.types';

type Props = {
  decision: CommentaryBase['decision'];
  originalQueryKey: string;
  source: string;
  reportClick: Function;
};

const titleCharacterLimit = 125;

export const CommentedDecision: FC<Props> = ({
  decision,
  originalQueryKey,
  source,
  reportClick,
}) => {
  const { accessPremium } = useUser();
  const { openRestrictedModal } = useRestrictedModal();

  const onClick = () => {
    if (!accessPremium) {
      openRestrictedModal({ source });
    } else {
      reportClick();
    }
  };

  const onMouseDown = (event: {
    nativeEvent: MouseEvent & { which: number };
  }) => {
    if (accessPremium && event.nativeEvent.which === 2) {
      reportClick();
    }
  };

  if (!decision || !decision.searchTitle) return null;

  const hyperlinkProps = accessPremium
    ? {
        href: buildUrlWithParameters(decision.referenceUrl, {
          source,
          original_query_key: originalQueryKey,
        }),
      }
    : {};

  return (
    <ExcerptRelated>
      <span className={styles.title}>
        <FormattedMessage id="CommentedDecision.tsx/1" />
      </span>
      <Hyperlink
        onClick={onClick}
        onMouseDown={onMouseDown}
        {...hyperlinkProps}
      >
        <span className={styles.link}>
          {decision.searchTitle.substring(0, titleCharacterLimit)}{' '}
          {decision.searchTitle.length > titleCharacterLimit ? '...' : ''}
        </span>
      </Hyperlink>
    </ExcerptRelated>
  );
};
